const state = {
  data: [],
  message: '',
  authenticated: false
}

export default state
